<section
  class="hero bg-blue-gradient-top-right stretch"
  [appStoryblok]="_editable()"
  aria-labelledby="hero-title"
>
  <div class="hero-content">
    <h1 id="hero-title" class="article-heading-2">{{ title() }}</h1>
    <h2 class="ui-heading-2">{{ description() }}</h2>
    <div class="search">
      <inexp-search-input
        [placeholder]="searchPlaceholder()"
        [buttonText]="searchButtonText()"
        [showAutocomplete]="true"
        (searchSubmit)="onSearch($event)"
        [isSearchEnabled]="isSearchEnabled()"
      />
    </div>
  </div>
</section>
